import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../../enums'
import * as dimensionFilter from '../dimension-filter'

// Aliases both the type and its namespace, so the fully qualified entity path
// doesn't have to be repeated in every transformer below
import Configuration = ents.extra.space.Report.Configuration.RoomSupportingInformation

export const FORMAT = graphql.transformers.IN.enumeration<
  ents.extra.space.Report.Format,
  graphql.schema.SpaceReportFormat
>({
  [ents.extra.space.Report.Format.Html]: graphql.schema.SpaceReportFormat.Html,
  [ents.extra.space.Report.Format.Excel]:
    graphql.schema.SpaceReportFormat.Excel,
  [ents.extra.space.Report.Format.Pdf]: graphql.schema.SpaceReportFormat.Pdf,
})

export const SORT_BY = graphql.transformers.IN.enumeration<
  Configuration.SortBy,
  graphql.schema.SpaceReportRoomSupportingInformationSortBy
>({
  [Configuration.SortBy.Building]:
    graphql.schema.SpaceReportRoomSupportingInformationSortBy.Building,
  [Configuration.SortBy.ResponsiblePerson]:
    graphql.schema.SpaceReportRoomSupportingInformationSortBy.ResponsiblePerson,
})

export const FILTER_INPUT = graphql.transformers.IN.object<
  Configuration.Filter,
  graphql.schema.SpaceReportRoomSupportingInformationFilterInput
>({
  clusterFilter: dimensionFilter.TRANSFORMER,
  employeeFilter: dimensionFilter.TRANSFORMER,
  functionalMethodologies: graphql.transformers.IN.default(
    graphql.transformers.IN.list(enums.methodology.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
  organizationFilter: dimensionFilter.TRANSFORMER,
  roomTypeFilter: dimensionFilter.TRANSFORMER,
  spaceFilter: dimensionFilter.TRANSFORMER,
})

export const CONFIGURATION_INPUT = graphql.transformers.IN.object<
  Configuration,
  graphql.schema.SpaceReportRoomSupportingInformationConfigurationInput
>({
  filter: graphql.transformers.IN.nonNull(FILTER_INPUT),
  format: graphql.transformers.IN.nonNull(FORMAT),
  showProjectInformation: transformers.PASS_THROUGH,
  showCalculatedRoomFunctionalPercentages: transformers.PASS_THROUGH,
  showEmployeeNumbers: transformers.PASS_THROUGH,
  showSalaryInformation: transformers.PASS_THROUGH,
  sortBy: graphql.transformers.IN.nonNull(SORT_BY),
})
